import { forwardRef, useRef } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { WORKER_STATUS } from "@bms/constants";
import { ColDef } from "ag-grid-community";

// eslint-disable-next-line react/display-name
export default forwardRef((props: any) => {
  const inputRef: any = useRef<HTMLInputElement>(null);
  const { column } = props;
  const options = () => {
    switch (column.colId) {
      case "status":
        return [
          // {
          //   value: "clear",
          //   label: "すべて",
          // },
          {
            label: WORKER_STATUS["long_holiday"],
            value: "long_holiday",
          },
          {
            label: WORKER_STATUS["day_off"],
            value: "day_off",
          },
        ];

      default:
        return [];
    }
  };

  const onBoxChanged = (input: SelectChangeEvent) => {
    if (input.target.value === "") {
      props.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }

    props.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged("greaterThan", input.target.value);
    });
  };

  return (
    <div className="floatingFilter-select">
      <Select
        defaultValue="絞り込み"
        variant="standard"
        ref={inputRef}
        onChange={onBoxChanged}
      >
        <MenuItem value="絞り込み" style={{ display: "none" }}>
          <span style={{ color: "#b9b9b9" }}>絞り込み</span>
        </MenuItem>
        {options().map((item) => (
          <MenuItem value={item.value} key={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
});

export const columns: ColDef[] = [
  {
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    maxWidth: 50,
    floatingFilter: false,
  },
  {
    headerName: "名前",
    field: "name",
    minWidth: 210,
  },
  {
    headerName: "勤務時間",
    field: "working_hour",
    // maxWidth: 150,
    minWidth: 150,
  },
  {
    headerName: "休み設定",
    field: "holiday_name",
    minWidth: 210,
  },
  {
    headerName: "休み範囲",
    field: "range",
    minWidth: 210,
  },
  {
    headerName: "状態",
    field: "status",
    minWidth: 100,
    // maxWidth: 100,
    cellRenderer: (e: any) => {
      const isDayOff = e.value === "day_off";
      const isRetired = e.value === "retired";
      const longHoliday = e.value === "long_holiday";

      return (
        <div
          className={`tag ${
            isRetired
              ? "bg-red"
              : isDayOff
              ? "bg-green"
              : longHoliday
              ? "bg-blue"
              : ""
          }`}
        >
          {isDayOff
            ? WORKER_STATUS["day_off"]
            : isRetired
            ? WORKER_STATUS["retired"]
            : longHoliday
            ? WORKER_STATUS["long_holiday"]
            : ""}
        </div>
      );
    },
  },
];

export const SORT_PARAMS = {
  name: "sort_name",
  status: "sort_status",
};
